import { store } from '../index';


export const API_ACTION_GETPERMISSIONSBYUSER = "Permission/GetPermissionsByUser";
export const API_ACTION_GETCOMPETENCESBYUSER = "Competence/GetCompetencesByUser";
export const API_ACTION_GETALLUSERSWITHDETAILS = "User/GetAllUsersWithDetails";
export const API_ACTION_SAVEUSER = "UserLogic/SaveUser";
export const API_ACTION_VALIDATEUSER = "User/ValidateUser";
export const API_ACTION_GETALLROLES = "Role";
export const API_ACTION_GETALLPLANNED = "Picking/Workflow/GetAllPlanned";
export const API_ACTION_GETPLANNED = "Picking/Workflow/GetPlanned";
export const API_ACTION_GETPICKINGDETAIL = "Picking/Workflow/GetPickingDetail";
export const API_ACTION_GETSCANNERDETAIL = "Picking/Workflow/GetScannerDetail";
export const API_ACTION_GETALLPAUSED = "Picking/Workflow/GetAllPausedAndStarted";
export const API_ACTION_GETPICKSTOCK = "Picking/Workflow/pickStock";
export const API_ACTION_SENDCHANGECARRIER = "Stock/ChangeCarrier";
export const API_ACTION_GETUSERBYID = "UserLogic/GetUserById";
export const API_ACTION_SENDCARRIERBYBARCODE = "Picking/Workflow/GetCarrierByBarcode";
export const API_ACTION_GETBYCARRIER = "Stock/GetByCarrier";
export const API_ACTION_GETBYCARRIERBARCODE = "Stock/GetByCarrierBarcode";
export const API_ACTION_SENDPAUSEWORKFLOW = "Picking/Workflow/PauseWorkflow";
export const API_ACTION_SENDFINISHWORKFLOW = "Picking/Workflow/FinishWorkflow";

export default class ApiHelper {
    static appSettings;  
}

export const ComposeUri = (action) => {

    return ApiHelper.appSettings.SILBLOXX_SHOPFLOOR_API_BASE_URL + action;
}

export const ComposeNodeRedUri = (action) => {

    return ApiHelper.appSettings.SILBLOXX_ORCHESTRATION_API_BASE_URL + action;
}

export const ComposeInterfaceUri = (action) => {
    return ApiHelper.appSettings.SILBLOXX_INTERFACE_API_BASE_URL + action;
}
export const ComposePickingUri = (action) => {
    return ApiHelper.appSettings.SILBLOXX_PICKING_API_BASE_URL + action;
}

export const  getAuthHeader = () => {
    var state = store.getState();
    var token = state.user.userToken;
    return token ? 'Bearer ' + token : '';
}

